import { FC } from "react";
import { useAppSelector } from "../../../store";
import { RoyaltyObj } from "../../../features/royalty/RoyaltyModels";
import {UserRole} from "../../../features/user/models/model";

export const OwnerCommission: FC<{commission: RoyaltyObj['owner_commission']}> = ({commission}) => {
    const userRole = useAppSelector(state => state.user.userRole);

    if(commission == null || (userRole !== UserRole.PLATFORM && userRole !== UserRole.OWNER)) return null;
    
    return <b>{commission * 1000 / 10}%</b>
}